import Chip, { ChipProps } from '@mui/material/Chip';

interface StatusChipProps extends Omit<ChipProps, 'color'> {
  isSuccess: boolean;
}

const StatusChip = ({ isSuccess, sx, ...props }: StatusChipProps) => (
  <Chip
    sx={[
      (theme) =>
        isSuccess
          ? {
              backgroundColor: theme.semantic.statusSuccessBg,
              color: theme.semantic.statusSuccess,
            }
          : { backgroundColor: theme.semantic.surfaceSunken, color: 'text.secondary' },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...props}
  />
);

export default StatusChip;
